import React from 'react';
import { Button, Icon, VStack } from '@chakra-ui/react';
import { LuArrowRight } from 'react-icons/lu';
import type { DonationFrequency } from '@kuow/core';

import { DonationTotalBar } from './DonationTotalBar';

interface DonationContinueSectionProps {
  amount: number;
  frequency: DonationFrequency;
  buttonLabel: React.ReactNode;
  onClick: () => void;
  disabled: boolean;
  loading?: boolean;
  loadingText?: React.ReactNode;
  showArrow?: boolean;
  variant?: React.ComponentProps<typeof Button>['variant'];
}

export const DonationContinueSection: React.FC<DonationContinueSectionProps> = ({
  amount,
  frequency,
  buttonLabel,
  onClick,
  disabled,
  loading = false,
  loadingText,
  showArrow = true,
  variant,
}) => {
  return (
    <VStack gap={0} alignSelf="center" pt={1.5} w="auto">
      <DonationTotalBar amount={amount} frequency={frequency} />
      <Button
        variant={variant}
        colorPalette="river"
        size="md"
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        loadingText={loadingText}
        px={12}
        w="full"
        borderTopRadius={0}
      >
        {buttonLabel}
        {showArrow ? <Icon as={LuArrowRight} /> : null}
      </Button>
    </VStack>
  );
};
